import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-landing-navbar',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './landing-navbar.component.html',
    styleUrls: ['./landing-navbar.component.css']
})
export class LandingNavbarComponent {
    showSolutionsDropdown = false;
    showResourcesDropdown = false;

    solutionsItems = [
        { label: 'Customer', link: '#customer' },
        { label: 'Industry', link: '#industry' }
    ];

    resourcesItems = [
        { label: 'Learning Library', link: '#learning-library' },
        { label: 'About Us', link: '#about-us' },
        { label: 'FAQ', link: '#faq' }
    ];

    toggleSolutions() {
        this.showSolutionsDropdown = !this.showSolutionsDropdown;
        this.showResourcesDropdown = false;
    }

    toggleResources() {
        this.showResourcesDropdown = !this.showResourcesDropdown;
        this.showSolutionsDropdown = false;
    }

    closeDropdowns() {
        this.showSolutionsDropdown = false;
        this.showResourcesDropdown = false;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.navbar-dropdown-container')) {
            this.closeDropdowns();
        }
    }
}
